import { createActions, handleActions, combineActions } from 'redux-actions';

const collection = 'ui';

const defaultState = {
  background: {
    current: 'blurred',
    previous: null,
  },
  header: {
    current: 'default',
    previous: null,
  },
  skipOnboarding: false,
  brand: 'default',
  conf: null,
};

const options = {
  prefix: collection,
};

const actions = createActions(
  {
    background: {
      BLACK: () => ({ background: 'black' }),
      DARK: () => ({ background: 'dark' }),
      WHITE: () => ({ background: 'white' }),
      BLURRED: () => ({ background: 'blurred' }),
      TRANSPARENT: () => ({ background: '' }),
      DEFAULT: () => ({ background: defaultState.background.current }),
      RESET: () => ({}),
    },
    header: {
      TRANSPARENT: () => ({ header: 'transparent' }),
      TRANSPARENT_BLACK: () => ({ header: 'transparent-black' }),
      DEFAULT: () => ({ header: 'default' }),
      RESET: () => ({}),
    },
    SKIP_ONBOARDING: () => ({}),
    RESET_ONBOARDING: () => ({}),
    SET_BRAND: (brand) => ({ brand }),
    SET_CONF: (conf) => ({ conf }),
  },
  options,
);

const reducer = handleActions(
  {
    background: {
      [combineActions('BLACK', 'DARK', 'WHITE', 'BLURRED', 'TRANSPARENT')]: (
        state,
        { payload: { background } },
      ) => ({
        ...state,
        background: {
          current: background,
          previous: state.background.current,
        },
      }),
      DEFAULT: (state) => ({
        ...state,
        background: defaultState.background,
      }),
      RESET: (state) => ({
        ...state,
        background: {
          current: state.background.previous,
          previous: state.background.current,
        },
      }),
    },
    header: {
      [combineActions('TRANSPARENT', 'TRANSPARENT_BLACK', 'DEFAULT')]: (
        state,
        { payload: { header } },
      ) => ({
        ...state,
        header: {
          current: header,
          previous: state.header.current,
        },
      }),
      RESET: (state) => ({
        ...state,
        header: {
          current: state.header.previous,
          previous: state.header.current,
        },
      }),
    },
    SKIP_ONBOARDING: (state) => ({
      ...state,
      skipOnboarding: true,
    }),
    RESET_ONBOARDING: (state) => ({
      ...state,
      skipOnboarding: defaultState.skipOnboarding,
    }),
    SET_BRAND: (state, { payload: { brand } }) => ({
      ...state,
      brand,
    }),
    SET_CONF: (state, { payload: { conf } }) => ({
      ...state,
      conf,
    }),
  },
  defaultState,
  options,
);

const selectors = {
  background: (state) => state[collection].background.current,
  header: (state) => state[collection].header.current,
  onboarding: (state) => !state[collection].skipOnboarding,
  brand: (state) => state[collection].brand,
  conf: (state) => state[collection].conf,
  brandConfig: () => ({}),
  poweredBy: () => ({}),
};

export { actions, selectors, reducer as default };
